module.exports = __webpack_public_path__ + "img/ping4.a8f4fb2b.png";